import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportZedal extends GuiListGeneric {
    constructor() {
        super("Zedal");
    }
}
